function DynamicItems() {
    this.constructor.apply(this, arguments);
}

DynamicItems.prototype = {

    loadPage: () => {
    },

    constructor(loadPage, $element, $timeout, $Loading) {
        this.loadPage = loadPage;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$Loading = $Loading;


        /** @type {number[]} Data pages, keyed by page number (0-index). */
        this.loadedPages = [];
        /** @type {number} Total number of items. */
        this.numItems = 0;
        /** @type {boolean} Whether the data has been loaded. */
        this.dataLoaded = false;

        /** @const {number} Number of items to fetch per request. */
        this.PAGE_SIZE = 20;

        this.items = [];

        this.fetchPage(0).finally(this.$Loading.blockUI())


    },
    // Required.
    getItemAtIndex(index) {
        // console.log('getItemAtIndex', index)
        let pageNumber = Math.floor(index / this.PAGE_SIZE);
        let pageStatus = this.loadedPages[pageNumber];
        if (pageStatus === undefined) { // loaded
            this.fetchPage(pageNumber);
        }
        if (this.items[index]) {
            return this.items[index];
        }
    },

    // Required.
    getLength() {
        return this.numItems;
    },
    /**
     * Fetches a page of items from the server.
     * @param pageNumber
     * @returns {angular.IPromise{void}}
     */
    fetchPage(pageNumber) {
        // console.log("fetchPage", pageNumber);
        // Set the page to null so we know it is already being fetched.
        this.loadedPages[pageNumber] = 0;

        // For demo purposes, we simulate loading more items with a timed
        // promise. In real code, this function would likely contain an
        // $http request.
        let startIndex = pageNumber * this.PAGE_SIZE;
        return this.loadPage({
            startIndex: startIndex,
            count: this.PAGE_SIZE
        }).then((result) => {
            // Trigger a new digest by using $timeout
            this.$timeout(() => {
                this.numItems = result.TotalCount;
                if (pageNumber === 0) {
                    this.loadedPages = [0]; // Reset loaded pages
                    this.items = [];
                    for (let i = 0; i < this.numItems; i++) {
                        this.items.push({})
                    }
                }
                result.Rows.forEach((item, i) => {
                    let index = startIndex + i;
                    Object.assign(this.items[index], item);
                })

                this.dataLoaded = true;
                this.loadedPages[pageNumber] = 1;
            });
        })
    },
    refresh() {
        return this.fetchPage(0);
    }
}


function VirtualListSelectorController() {
    this.constructor.apply(this, arguments);
}

VirtualListSelectorController.$inject = [
    '$scope',
    'MKioskService',
    '$timeout',
    'mdPanelRef',
    '$q',
    '$translationService',
    '$Loading',
    'onClose',
    'loadData',
    'selectedItems',
    'title',
    'options'
];
VirtualListSelectorController.prototype = {
    /**
     *
     * @param $scope {angular.IScope}
     * @param MKioskService {MKioskService}
     * @param $timeout {angular.ITimeoutService}
     * @param mdPanelRef {mdPanelRef}
     * @param $q {angular.IQService}
     * @param $translationService {$translationService}
     * @param $Loading {Loading}
     * @param onClose {Function}
     * @param loadData {Function}
     * @param selectedItems {any[]}
     * @param title {string}
     * @param options {Object}
     *
     */
    constructor($scope, MKioskService, $timeout, mdPanelRef, $q, $translationService, $Loading, onClose, loadData, selectedItems, title, options) {
        this.$scope = $scope;
        this.MKioskService = MKioskService;
        this.$timeout = $timeout;
        this.mdPanelRef = mdPanelRef;
        this.$q = $q;
        this.$translationService = $translationService;
        this.$Loading = $Loading;
        this.onClose = onClose;
        this.loadData = loadData;
        this.selectedItems = selectedItems || [];
        this.title = title;

        // Init
        this.searchText = '';
        this.isShowSearch = false;
        this.itemSize = 64;
        this.multiple = false;
        this.searchable = true;
        this.lazyLoad = false;




        // Set default value
        this.templateItem = options.templateItem;
        if (options.itemSize !== undefined) {
            this.itemSize = options.itemSize;
        }
        if (options.multiple !== undefined) {
            this.multiple = options.multiple;
        }
        if (options.searchable !== undefined) {
            this.searchable = options.searchable;
        }
        if (options.lazyLoad !== undefined) {
            this.lazyLoad = options.lazyLoad;
        }

        this.$scope.vm = this;


    },
    bindEvents() {
        //hide panel when close client
        this.$scope.$on("$destroy", () => {
            delete this.dynamicItems;
            if (this.mdPanelRef)
                this.mdPanelRef.close();
        });


        this.$element.find('.keysearch').on("focus", () => {
            this.isShowSearch = true;
            this.safeApply();
        });

        // Update list when resize
        this.$element.resize(() => {
            let controller = this.$element.find("md-virtual-repeat-container").data("$mdVirtualRepeatContainerController");
            if (controller) {
                controller.updateSize();
            }
        });


    },
    closeSearch() {
        this.isShowSearch = false;
        this.searchText = "";
        this.filter()
    },
    ready() {
        this.$element = $("#virtual-list-selector");
        this.dynamicItems = new DynamicItems(this._loadData.bind(this), this.$element, this.$timeout, this.$Loading);
        this.bindEvents();
    },

    _loadData(data) {
        if(data){
            data.searchText = this.searchText;
        }
        return this.loadData(data).then((result) => {
            result.Rows.forEach((row) => {
                row.Selected = this.selectedItems.findIndex((selectedItem) => {
                    return row.Id === selectedItem.Id;
                }) !== -1;
            })
            return result;
        });
    },
    filter() {
        return this.dynamicItems.refresh();
    },


    clearSearch() {
        this.searchText = "";
        this.$element.find('.keysearch').focus();
        this.filter();
    },
    goBack(data) {
        this.onClose(data);
        this.$scope.$destroy(); // Have to destroy $scope when panel is closed
    },
    startSearch() {
        this.filter();
    },
    selectItem(item) {
        if (!item.Id) {
            return;
        }
        if (this.multiple) {
            let selectedIndex = this.selectedItems.findIndex((selectedItem) => {
                return item.Id === selectedItem.Id;
            });
            if (selectedIndex !== -1) {
                item.Selected = false;
                this.selectedItems.splice(selectedIndex, 1);
            } else {
                item.Selected = true;
                this.selectedItems.push(item);
            }

        } else {
            this.goBack(item);
        }

    },
    safeApply(fn) {
        let phase = this.$scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        } else {
            this.$scope.$apply(fn);
        }
    },

    save() {
        this.goBack(this.selectedItems);
    },

    onReload() {
        return this.dynamicItems.refresh();
    }
};

angular.module('shared.virtual-list-selector', []).controller('VirtualListSelectorController', VirtualListSelectorController);